var exports = {
  "V": "ToolbarButtonSkeleton__58fh4l",
};

module.exports = exports;
